export enum WI_TYPE  {
    ADMIN =  "AD",
    TECHNICAL = "WK",
    APPEAL_ON_COS = "CA",
}
export enum COMMITTEE_LEVELS  {
    All= "",
    MC= "MC",
    SC= "SC"
}

export enum COMMITTEE_LEVELS_ID  {
    All= "0",
    MC= "2",
    SC= "1"
}
export const SYSTEM = -1;
export const EXCLUDED_DRAFT_ACTION_CODES = ["5", "5a"];
export const EXCLUDED_WI_TYPE_ID = [3, 6];
export const CC_BADGE_LABEL = "CC";
export const REMOVEDITEM_BADGE_LABEL = "Item Removed";
export enum BallotStatusEnum {
  Prepublish = 1,
  Published = 2,
  Closed = 3,
  External = 4,
  Inactive = 5,
  PendingPublication = 6
}

export enum FILE_LIST_INFO {
  ListFile = 1, // Initial
  ExistedDocumentsList = 2,  // List Existing Documents
  ErrorFileFormatList = 3, // List Error File format Documents
  ErrorFileSizeList = 4, // List Error File Size Documents
  ErrorFileNameValidationList = 5, // List Error File Name Validation Documents
}

export enum BallotTypeEnum {
  Technical = 1,
  Admin = 2
}

export enum CommentRequired {
  Disabled = 0,
  Enabled = 1
}

export enum TallyAllAdmin {
  Disabled = 1,
  Enabled = 2
}

export const ADMINISTRATIVE = "ADMINISTRATIVE";

export enum BALLOT_STATUS {
    Active = "active",
    Inactive = "inactive"
}

export const BallotFolderStatus: Record<number, string> = {
  1: "Prepublish",
  2: "Published",
  3: "Closed",
  4: "External",
  5: "Inactive",
  6: "Pending Publication",
};

export const BQBallotActionOption = [
  { text: "Select", value: 0, key: "Select" },
  { text: "Uphold Negative", value: 26, key: "Uphold Negative" },
  { text: "Confirmatory", value: 25, key: "Confirmatory" },
];

export const BQ_BALLOT_ACTION = {
  CONFIRMATORY : 25,
  UPHOLD_NEGATIVE : 26
}
export const PUBLISH_TIME = "08:00 PM (EST)";
export const FORCED_CLOSE_TIME = "08:00 PM (EST)";

export enum Apps {
  IA = "IA",
  BEVSON = 'BEVSON',
  STDMAINT = 'STDMAINT'
}
export enum AppModule {
  Committee = "committee",
  Member = "member",
  WorkItem = 'workitem',
  Ballot = 'ballot',
  user = "user"
}

export const BALLOT_QUEUE_LEVELS  = {
  1: "MC",
  2: "SC",
  5: "MC"
}

export enum COMMON_LABELS {
  GLOBAL = "GLOBAL"
}

export enum PERMISSION_NAVIGATION {
  ballot = "ballot",
  ballotDetail = "ballotDetail",
  ballotQueue = "ballotQueue",
  addBallotItems= "ballotQueue",
  workitem = "workitem",
  workitemAuditLog = "workitem",
  workItemDetail= "workitem",
  navigateWithParams = "workitem",
  "manage-ansi-committee-standard" = "manage-ansi-committee-standard",
  "manage-108-bsr" = "manage-108-bsr",
  "manage-109-bsr" = "manage-109-bsr",
  "ansi-auditlog"="ansi-auditlog",
   "pins-report"="pins-report"
}

export enum VOTE_TYPE_ID  {
  AFFIRMATIVE = 1,
  AFFIRM_WITH_COMMENT = 2,
  NEGATIVE_WITH_STATEMENT = 3,
  ABSTAIN = 4,
  ABSTAIN_WITH_COMMENT = 5,
}

export enum VOTE_TYPE_DESCRIPTION {
  AFFIRMATIVE = "Affirmative",
  AFFIRM_WITH_COMMENT = "Affirm with Comment",
  NEGATIVE = "Negative",
  NEGATIVE_WITH_STATEMENT = "Negative with Statement",
  ABSTAIN = "Abstain",
  ABSTAIN_WITH_COMMENT = "Abstain with Comment",
}

export const NO_DATE = "0001-01-01T00:00:00";

export enum VOTE_AFFIRM_ABSTAIN_TEXT {
  AFFIRMATIVE = "Affirmative all items, except as marked",
  ABSTAIN = "Abstain all items, except as marked"
}

export const ALLOWED_FILE_FORMATS = ["docx", "pptx", "xlsx"]

export const TERMINOLOGY_STANDARDS = ["13", "17", "18", "21"];

export const DRAFT_STATUS: { [key: number]: string } = {
  1: "Approved",
  2: "Partial Approval",
  3: "Balloting In Process",
  4: "Withdrawn Draft",
  5: "New Draft",
  6: "Balloting On Hold",
  7: "Withdrawn - Reballot"
};

export const PUBLISH_BALLOT_TABLE_HEADERS = ["TotalAffirm", "TotalNegative", "AbstainWithComment", "PercentageAffirmative", "TotalAbstained", "AffirmWithComment"];

export const WI_STATUS_FIELDS_MAP = {
  Patented: ["new standard", "revision"],
  EmergencyResponse: ["new standard", "revision"],
  EmergencyDescription: ["new standard", "revision"],
  NotifyOthers: ["new standard", "revision"],
  ExistingStandards: ["new standard"],
  OrganizationList: ["new standard", "revision"]
};

export const BALLOT_ITEM_STATUSES: Record<string, number> = {
  "Pending Approval": 19,
  "Item Removed": 17,
  "Overdue/W": 14,
  "Withdrawn": 13,
  "Unresolved Negatives": 12,
  "Reballot": 11,
  "Pending Next Level": 10,
  "Passed": 9,
  "Open": 8,
  "Not Passed": 7,
  "Hold SOC": 6,
  "Hold": 5,
  "APP-HOLD": 4,
  "Approved": 3,
  "New": 2,
  "HLD BY REQ": 1
};

//This ENUM will change in future as per requirment of ballot item status id
export const BALLOTITEM_STATUSES: { [key: string]: number } = {
  BALLOT_ITEM_APPROVED: 3,
  PASSED_TO_NEXT_LEVEL: 9,
  ITEM_REMOVED: 17,
  PENDING_NEXT_LEVEL: 10
};

export enum StandardType {
  SpecificationFor = 1,
  TestMethodFor = 2,
  TestMethodsFor = 3,
  MethodOf = 4,
  MethodsOf = 5,
  PracticeFor = 6,
  PracticesFor = 7,
  RecommendedPracticeFor = 8,
  RecommendedPracticesFor = 9,
  GuideFor = 10,
  GuidesFor = 11,
  GuidelinesFor = 12,
  DefinitionsOfTermsRelatingTo = 13,
  MethodsFor = 14,
  MethodFor = 15,
  GuideTo = 16,
  TerminologyOf = 17,
  TerminologyRelatingTo = 18,
  ClassificationFor = 19,
  ClassificationOf = 20,
  TerminologyFor = 21,
  TestMethodOf = 22,
  TestMethodsOf = 23,
  TablesFor = 24,
  PerformanceSpecification = 25
}

export enum IS_IN_BALLOT_QUEUE {
  NOT_PRESENT = 0,           // Wk NOT Present in Ballot Queue
  PRESENT = 1,               // Wk Present in Ballot Queue
  PRESENT_CURRENT_WITN = 2   // Wk Present in Ballot Queue for Current WITN
}

export const IS_IN_BALLOT_QUEUE_LABELS: Record<IS_IN_BALLOT_QUEUE, string> = {
  [IS_IN_BALLOT_QUEUE.NOT_PRESENT]: "",
  [IS_IN_BALLOT_QUEUE.PRESENT]: "In Ballot Queue (Unassigned)",
  [IS_IN_BALLOT_QUEUE.PRESENT_CURRENT_WITN]: "In Ballot Queue (Assigned)"
};
export const DRAFTACTIONGROUPS = {
  Group1: ["1", "1A", "1B"],
  Group2: ["2", "2A", "2B"],
  Group4: ["4", "4A", "4B", "4C"],
  Group5: ["5", "5A"],
  Group6: ["8"],
  Group7: ["1", "1A"],
  Others: ["6", "7"],
}

export const emailRegex = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/i

export const testEmailRegex = /^auto_mem_.*@yopmail\.com$/i

export const phoneRegex = /^[0-9()\-\s+]*$/;

export enum STATISTICS_TYPE {
  TECHNICAL_VOTES = 1,
  ADMIN_OFFICIAL_VOTES = 2,
  ADMIN_ALL_VOTES = 3
}
export enum WorkItemType {
  NewStandard = 1,
  Revision = 2,
  Reapproval = 3,
  Withdrawal = 4,
  Reinstatement = 5,
  ReapprovalWithEditorialChange = 6,
  WithdrawalWithReplacement = 7,
  Administrative = 8
}

export enum DraftActionId {
  Convert_2_to_2A = 1,
  Convert_2_to_2B = 2,
  New_Standard = 3,
  Revision_of_New_Std = 4,
  New_Standard_Content = 5,
  Revision = 6,
  Revision_W_Title_Chg = 7,
  Rev_W_Chg_in_Desig = 8,
  Adopt_as_a_Standard = 9,
  Adopt_as_a_Std_W_Rev = 10,
  Reinstate = 11,
  Reinstate_W_Ed_Chg = 12,
  Reinstate_W_Rev = 13,
  Reinstate_W_New_Des = 14,
  Reapproval = 15,
  Reapproval_W_Ed_Chg = 16,
  Withdraw_No_Repl = 17,
  Withdraw_Replace_By = 18,
  Withdraw_Combined = 19,
  _1_Yr_Extension = 20,
  Jurisdiction_Chg = 21,
  Administrative = 22,
  Generic_Hazard_Cavt = 23,
  Permission_Prov_Std = 24,
  Confirmatory = 25,
  Uphold_Negative = 26,
  Convert_4_to_4A = 27,
  Convert_4_to_4B = 28,
  Convert_4_to_4C = 29,
  Appealed_Negative = 30,
  Convert_5_to_5A = 31,
  Appeal_on_Cos = 32
}
export const cosCommittee = "COS"
export const fifteenthOfMonth = 15

export enum WorkItemtatus {
  DraftUnderDevelopment = 1,
  InBalloting = 2,
  Closed = 3,
  Approved = 4
}

export const DRAFT_STATUS_ID: { [key: number]: string } = {
  1: "Ballot Item Approved",
  2: "Partial Approval",
  3: "In Balloting",
  4: "Withdrawn Draft",
  5: "Draft Under Development",
  6: "Balloting On Hold",
  7: "Withdrawn - Reballot",
  8: "Passed To Next Level",
  9: "Pending Approval",
  10: "Unresolved Negatives",
  11: "Prepublish",
  12: "Pending Publication",
  13: "Item Removed",
  14: "Closed",
  15: "Pending Next Level"
};
export const DRAFT_STATUSES: { [key: string]: number } = {
  BALLOT_ITEM_APPROVED: 1,
  PARTIAL_APPROVAL: 2,
  IN_BALLOTING: 3,
  WITHDRAWN_DRAFT: 4,
  DRAFT_UNDER_DEVELOPMENT: 5,
  BALLOTING_ON_HOLD: 6,
  WITHDRAWN_REBALLOT: 7,
  PASSED_TO_NEXT_LEVEL: 8,
  PENDING_APPROVAL: 9,
  UNRESOLVED_NEGATIVES: 10,
  PREPUBLISH: 11,
  PENDING_PUBLICATION: 12,
  ITEM_REMOVED: 13,
  CLOSED: 14,
  PENDING_NEXT_LEVEL: 15,
  SOCIETY_REVIEW: 16,
  RECONSIDER: 17,
};
export const FLY_BALLOT_LEVEL_ID : { [key: string]: number } = {
  FLYOVER : 2,
  COS_FLYOVER : 1
};

export const NON_SORTABLE_ITEMS = ["AffirmWithComment", "TotalAffirm", "TotalAffirm", "TotalNegative", "AbstainWithComment", "PercentageAffirmative", "TotalAbstained"];

export const PAGE_ID = {
  BALLOT_ITEM_DETAIL_RESULT: 11,
  VOTERS_NEGATIVE_COMMENTS_RULING_RATIONALE: 12,
}

export const BALLOT_LEVEL_ID = {
  MAIN: 1,
  SUB: 2,
  COS: 3,
  CONCURRENT:5,
  SOCIETY: 6
}

export const COMMITTEE_LENGTH = {
  MAIN: 3,
  SUB: 6,
  SECTION: 9
}

export const GridType = {
  Negatives: "Negatives",
  Comments: "Comments",
}

export const PRE_SIGNED_URL_SOURCE = {
  NEGATIVE_RESOLUTION: 'NEGATIVE_RESOLUTION',
};

export enum DMS_ACTION_ID {
  NEW = 1,
  REVISION = 2,
  REVISION_OF_NEW_STANDARD = 3,
  REVISION_WITH_TITLE_CHANGE = 4,
  REVISION_WITH_CHANGE_IN_DESIGN = 5,
  REINSTATE_WITH_EDITORIAL_CHANGE = 6,
  REINSTATEMENT = 7,
  REINSTATE_WITH_REVISION = 8,
  REAPPROVAL = 9,
  REAPPROVAL_WITH_EDITORIAL_CHANGES = 10,
  WITHDRAWAL = 11,
  WITHDRAWAL_WITH_REPLACEMENT = 12,
  ADMIN = 13,
  UPHOLD_NEGATIVE = 14,
  REINSTATE_WITH_NEW_DESIGNATION = 15,
  WITHDRAWAL_COMBINED = 16,
  CONFIRMATORY = 17
}

export const DMS_BT_BALLOT_ACTION_MAPPING: Record<number, number> = {
  [DraftActionId.New_Standard]: DMS_ACTION_ID.NEW,
  [DraftActionId.Revision]: DMS_ACTION_ID.REVISION,
  [DraftActionId.Revision_of_New_Std]: DMS_ACTION_ID.REVISION_OF_NEW_STANDARD,
  [DraftActionId.Revision_W_Title_Chg]: DMS_ACTION_ID.REVISION_WITH_TITLE_CHANGE,
  [DraftActionId.Rev_W_Chg_in_Desig]: DMS_ACTION_ID.REVISION_WITH_CHANGE_IN_DESIGN,
  [DraftActionId.Reinstate_W_Ed_Chg]: DMS_ACTION_ID.REINSTATE_WITH_EDITORIAL_CHANGE,
  [DraftActionId.Reinstate]: DMS_ACTION_ID.REINSTATEMENT,
  [DraftActionId.Reinstate_W_Rev]: DMS_ACTION_ID.REINSTATE_WITH_REVISION,
  [DraftActionId.Reapproval]: DMS_ACTION_ID.REAPPROVAL,
  [DraftActionId.Reapproval_W_Ed_Chg]: DMS_ACTION_ID.REAPPROVAL_WITH_EDITORIAL_CHANGES,
  [DraftActionId.Withdraw_No_Repl]: DMS_ACTION_ID.WITHDRAWAL,
  [DraftActionId.Withdraw_Replace_By]: DMS_ACTION_ID.WITHDRAWAL_WITH_REPLACEMENT,
  [DraftActionId.Administrative]: DMS_ACTION_ID.ADMIN,
  [DraftActionId.Uphold_Negative]: DMS_ACTION_ID.UPHOLD_NEGATIVE,
  [DraftActionId.Reinstate_W_New_Des]: DMS_ACTION_ID.REINSTATE_WITH_NEW_DESIGNATION,
  [DraftActionId.Withdraw_Combined]: DMS_ACTION_ID.WITHDRAWAL_COMBINED,
  [DraftActionId.Confirmatory]: DMS_ACTION_ID.CONFIRMATORY
};

export enum WORKITEM_TYPE_ID {
  NEW_STANDARD = 1,
  REVISION = 2,
  REAPPROVAL = 3,
  WITHDRAWAL = 4,
  REINSTATEMENT = 5,
  REAPPROVAL_WITH_EDITORIAL_CHANGE = 6,
  WITHDRAWAL_WITH_REPLACEMENT = 7,
  ADMINISTRATIVE = 8
}

export const WORKITEM_DMS_ACTION_MAPPING: Record<WORKITEM_TYPE_ID, DMS_ACTION_ID> = {
  [WORKITEM_TYPE_ID.NEW_STANDARD]: DMS_ACTION_ID.NEW,
  [WORKITEM_TYPE_ID.REVISION]: DMS_ACTION_ID.REVISION,
  [WORKITEM_TYPE_ID.REAPPROVAL]: DMS_ACTION_ID.REAPPROVAL,
  [WORKITEM_TYPE_ID.WITHDRAWAL]: DMS_ACTION_ID.WITHDRAWAL,
  [WORKITEM_TYPE_ID.REINSTATEMENT]: DMS_ACTION_ID.REINSTATEMENT,
  [WORKITEM_TYPE_ID.REAPPROVAL_WITH_EDITORIAL_CHANGE]: DMS_ACTION_ID.REAPPROVAL_WITH_EDITORIAL_CHANGES,
  [WORKITEM_TYPE_ID.WITHDRAWAL_WITH_REPLACEMENT]: DMS_ACTION_ID.WITHDRAWAL_WITH_REPLACEMENT,
  [WORKITEM_TYPE_ID.ADMINISTRATIVE]: DMS_ACTION_ID.ADMIN
};

export const AnsiModules = [
  { text: "All", value: "", key: "All" },
  { text: "ANSI Committee/Standard", value: "ANSICOMMITTEEANDSTANDARDSCOMPONENT", key: "ANSI Committee/Standard" },
  { text: "PINS Reports", value: "ANSI | ANSI PINS", key: "PINS Reports" },
  { text: "BSR108", value: "ANSI | BSR108", key: "BSR108" },
  { text: "BSR109", value: "ANSI | BSR109", key: "BSR109" }
];
export const DocumentMasterTypeEnum = {
   BSR108: 129,
   BSR109: 130,
   ANSIPINSDaily: 131,
   ANSIPINSRemoval: 132,
   BSR108Removal : 133
}

export const AnsiModuleEnum = {
  ANSICommitteeAndStandardsComponent : "ANSICOMMITTEEANDSTANDARDSCOMPONENT",
  PINSReports : "ANSI | ANSI PINS",
  BSR108: "ANSI | BSR108",
  BSR109 : "ANSI | BSR109"
}
export const AuditLogTypeEnum = {
  Add: 1,
  Edit: 2,
  Delete: 3,
  Manual_Add: 4,
  PR_Date_Add: 5,
  PR_Date_Edit: 6,
}

export const AnsiAuditLogEnum = {
   Add: "Added to ANSI",
   Edit: "ANSI Committee Updated",
   Delete: "Deleted",
   Generated:"Generated",
   Manual_Add:"Added Manually",
   PR_Date_Add:"PR Dates Added",
   PR_Date_Edit:"PR Dates Edited"
}

export const OwnerType = {
  StaffUser: 0,
  Member: 1
};
